import { useCallback } from 'react';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer';
import { ROUTE_EXTERNAL_LOGIN } from '~/components/router/constants';
import { useRouter } from '~/utils/navigation';
import { setPostAuthLocation } from '~/components/authentication/ducks';
import { useDispatch } from 'react-redux';

interface RedirectOptions {
	options?: object;
	from?: string;
}

const useExternalLogin = () => {
	const router = useRouter();
	const transformPath = useContextualPathTransformer();
	const dispatch = useDispatch();

	const redirectToExternalLogin = useCallback(
		({ options, from }: RedirectOptions = {}) => {
			const state = from ? { from } : {};
			if (from) {
				dispatch(setPostAuthLocation(from));
			}
			// TODO (navigation) - use search params or redux for state
			router.push(transformPath(ROUTE_EXTERNAL_LOGIN, options), { state });
		},
		[router, transformPath, dispatch]
	);

	return {
		redirectToExternalLogin
	};
};

export default useExternalLogin;
